import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import { IFilters } from "@/interfaces/Fetch";
import {
  useDeleteCompanyCourseNoteMutation,
  useGetCompanyCourseNotesQuery,
} from "@/services/companies/courses/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { FC, useEffect, useState } from "react";
import { ToastContentProps, toast } from "react-toastify";
import NotesCard from "../NotesCard";

const CompanyCourseNotesCard: FC<
  PaginateCardProps & { companyId: string; courseId: string }
> = ({ companyId, courseId, onGetTotal }) => {
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 15,
  });

  useEffect(() => {
    setFilters((prev) => ({ ...prev, id: companyId }));
  }, [companyId]);

  const { data, isLoading, isError, error } = useGetCompanyCourseNotesQuery([
    companyId,
    courseId,
    filters,
  ]);

  const [deleteCompanyCourseNoteAsync] = useDeleteCompanyCourseNoteMutation();

  const onDeleteNote = (id: string) => {
    toast.promise(
      deleteCompanyCourseNoteAsync([companyId, courseId, id]).unwrap(),
      {
        pending: "Suppression de la note en cours...",
        success: {
          render() {
            return (
              <p style={{ marginBottom: 0, textAlign: "center" }}>
                La note à bien été supprimée 🤩
              </p>
            );
          },
        },
        error: {
          render({ data }: ToastContentProps<FetchBaseQueryError>) {
            if (data?.status === 422) {
              return "Les champs que vous avez remplis semblent être incorrects.";
            }

            return "Une erreur est survenue";
          },
        },
      }
    );
  };

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader absolute />;
  } else if (isError) {
    return <ErrorComponent error={error} absolute returnButton />;
  }

  return (
    <NotesCard
      data={data?.data}
      meta={data?.meta}
      filters={filters}
      setFilters={setFilters}
      onRemove={onDeleteNote}
    />
  );
};

export default CompanyCourseNotesCard;
